import React, { Component } from 'react';
import { Icon } from '@material-ui/core';
import './EditableText.scss';


class EditableText extends Component {
  state = { isEditing: false };
  inputRef = null;

  handleEdit() {
    const { isEditing } = this.state;
    if (this.props.canEdit) {
      this.setState({ isEditing: !isEditing }, () => {
        this.inputRef.focus();
      });
    }
  }

  handleUpdate(e) {
    const { handleUpdate } = this.props;
    this.setState({ isEditing: false });
    handleUpdate(e);
  }

  render() {
    const { isEditing } = this.state;
    const { placeholder, value, onChange, maxWidth, canEdit, onBlur, onClick } = this.props;
    return (
      <div className={isEditing ? "editable-field-wrapper" : ""}>
        <div onClick={this.handleEdit.bind(this)} className={isEditing ? 'hide-title' : canEdit ? 'title self-title' : 'title'}>
          <div className="job-title-text">{placeholder}</div>
          <Icon>create</Icon>
        </div>
        <div style={{ maxWidth }} className={isEditing ? 'show-edit-job' : 'edit-job'}>
          <input
            onBlur={(e) => {
              if (onBlur) onBlur(e);
              this.setState({ isEditing: false });
            }}
            maxLength={50}
            onKeyUp={(e) => { if (e.key === "Enter") this.handleUpdate(e); }}
            onChange={(e) => onChange(e.target.value)}
            value={value}
            id="job-title"
            onClick={onClick}
            ref={(ref) => this.inputRef = ref}
          />
        </div>
        {isEditing && <Icon className="job-title-check" onMouseDown={(e) => {
          e.stopPropagation();
          this.handleUpdate(e);
        }}>check</Icon> }
      </div>
    );
  }
}

export default EditableText;


// WEBPACK FOOTER //
// ./src/components/EditableText.js